export default __webpack_public_path__ + "static/media/order-up.f7b340b3.svg";